enum VersionPaths {
  AUTH_API = 'ApplicationInfo',
  CONTENT_SCRAPE_API = 'api/ApplicationInfo',
}

export default VersionPaths;
